<div *ngIf="isFromAudit" class="audit title">
    Audit Details
</div>
<div class="projectInfo">
    <div *ngIf="!isFromAudit" class="title">
        Audit Details
    </div>
    <div class="projectInfoDetails row m-0">
        <div class="info col-md-6 col-lg-4 col-sm-12 mb-1">
            <div class="row m-0">
                <span class="text-style col-4 pl-0">Project Name:</span>
                <span class="project-value col-8">{{projectDetail?.projectName}}</span>
            </div>
        </div>
        <div class="info col-md-6 col-lg-4 col-sm-12 mb-1">
            <div class="row m-0">
                <span class="text-style col-4 pl-0">Manager:</span>
                <span class="project-value col-8">{{projectDetail?.manager}}</span>
            </div>
        </div>
        <!-- <div class="info col-md-6 col-lg-4 col-sm-12 mb-1">
            <div class="row m-0">
                <span class="text-style col-4 pl-0">Start Date:</span>
                <span class="project-value col-8">{{projectDetail?.startDate | date: 'MM-dd-yyyy'}},{{noOfdaysLeftToCompleteTheAudit}}</span>
            </div>
        </div> -->
        <div class="info col-md-6 col-lg-4 col-sm-12 mb-1">
            <div class="row m-0">
                <span class="text-style col-4 pl-0">{{(noOfdaysLeftToCompleteTheAudit > 0) ? "No of days left:" : "Dead line completed before:"}}</span>
                <span class="project-value col-8 
                    {{ (noOfdaysLeftToCompleteTheAudit <= 5) ? 'days_color1' : 
                       (noOfdaysLeftToCompleteTheAudit > 5 && noOfdaysLeftToCompleteTheAudit <= 10) ? 'days_color2' : 'days_color1_default' }}">
                    {{(noOfdaysLeftToCompleteTheAudit > 0) ? noOfdaysLeftToCompleteTheAudit : (noOfdaysLeftToCompleteTheAudit * -1) }} days
                </span>
            </div>
        </div>
        <div class="info col-md-6 col-lg-4 col-sm-12 mb-1">
            <div class="row m-0">
                <span class="text-style col-4 pl-0">Auditor:</span>
                <span class="project-value col-8">{{projectDetail?.auditior}}</span>
            </div>
        </div>
        <!-- *ngIf="isAuditor && projectStatusList?.length > 0" -->
        <!-- <div class="manager col-md-6 col-lg-4 col-sm-12 mb-1" >
            <div class="row m-0">
                <span class="text-style col-4 pl-0">Status:</span>
                <span class="project-value col-8" [(ngModel)]="selectedProjectStatusId">{{ getStatusDescription(selectedProjectStatusId) }}</span>
                {{projectDetail?.status ?? "Unknown Status"}},{{selectedProjectStatusId}},
            </div>
        </div> -->
        <div class="manager col-md-6 col-lg-4 col-sm-12 mb-1" >
            <div class="row m-0">
                <span class="text-style col-4 pl-0">Status:</span>
                <span class="project-value col-8" [(ngModel)]="selectedProjectStatusDescription">{{selectedProjectStatusDescription ?? (projectDetail?.status ?? "Unknown Status")}}</span>
            </div>
        </div>
        <div class="info col-md-6 col-lg-4 col-sm-12 mb-1">
            <div class="row m-0">
                <span class="text-style col-4 pl-0">Technology:</span>
                <span class="project-value col-8">{{projectDetail?.technologyStack}}</span>
            </div>
        </div>
    </div>
    <div *ngIf="!isFromAudit">
        <div class = "addmore">
            <span class = "add" (click)="openOrCloseHistoryPopUp()">Comments History</span>
        <!-- <div *ngIf="showMoreDetailsLink">
            <span class="add" (click)="navigateToEditPage()">+ More Audit Details</span>
        </div> -->
    </div>
</div>
</div>